module.exports = __webpack_public_path__ + "static/media/sculpture4.35a79d69.jpg";